import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function List() {
    const profileFilter = chooseProfileFilter();
    const { keys } = useKeysStore();
    const pathFrontEnd = '/reports/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}demonstratives/delete`,
        endpoint: config.endpoints.backend + 'demonstratives/getall'
    }

    const pathsForm = {
        endpointSave: config.endpoints.backend + 'demonstratives/save',
        endpointGetById: config.endpoints.backend + 'demonstratives/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : null,
            {
                name: 'period',
                name_start: 'publish_start',
                name_end: 'publish_end',
                type: 'date_period',
                label: 'Data',
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Parecer',
        labelTitleButtonAdd: 'Incluir novo Parecer',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter,
            pdc_demonstrative_type_id: keys?.default_foreign_key?.pdc_demonstrative_types?.report
        },
        columns: [
            {
                name: 'project',
                label: 'Projeto',
                width: "10%"
            },
            {
                name: 'publish_date',
                label: 'Data Base'
            },
            {
                name: 'created_at',
                label: 'Data de Criação'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        validateOnChange: true,
        hiddenValues: {
            pdc_demonstrative_type_id: keys?.default_foreign_key?.pdc_demonstrative_types?.report
        },
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'publish_date',
                type: 'date',
                label: 'Data Base',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'obs',
                type: 'text',
                label: 'Descrição',
                validations: {
                    required: false
                },
                maxLength: 100
            },
            {
                name: 'file',
                type: 'fileS3',
                label: 'Arquivo',
                validations: {
                    required: true
                },
                columnSize: 12
            },
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Parecer'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
